// extracted by mini-css-extract-plugin
export default {"header":"header_header__Xrmhv","input":"header_input__+a1y8"};